/** Cuántas páginas se muestran enteras antes de empezar a resumir con "…". */
const PAGINAS_SIN_RESUMIR = 7;

/**
 * Páginas a mostrar en un paginador numerado: todas si son pocas; si no, la
 * primera, la última y una ventana alrededor de la actual, con `'gap'` donde se
 * saltean números.
 */
export function paginasVisibles(page: number, total: number): (number | 'gap')[] {
  if (total <= PAGINAS_SIN_RESUMIR) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const cercanas = [1, total, page, page - 1, page + 1].filter((p) => p >= 1 && p <= total);
  const ordenadas = [...new Set(cercanas)].sort((a, b) => a - b);

  const out: (number | 'gap')[] = [];
  let anterior = 0;
  for (const p of ordenadas) {
    // Un hueco de UNA sola página se rellena con el número: "1 … 3" ocupa lo
    // mismo que "1 2 3" y encima esconde una página alcanzable.
    if (anterior && p - anterior === 2) out.push(anterior + 1);
    else if (anterior && p - anterior > 2) out.push('gap');
    out.push(p);
    anterior = p;
  }
  return out;
}
